import { useRef } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useWalkInZoneConfirmStore } from "@/store/walk-in-zone-confirm-store";

/** Asks before a reservation is placed by hand in a walk-ins-only zone. */
export function WalkInZoneConfirmDialog() {
  const pending = useWalkInZoneConfirmStore((s) => s.pending);
  const close = useWalkInZoneConfirmStore((s) => s.close);
  // The dialog animates out after ``pending`` clears; keep the last names
  // so the title doesn't read "son solo para walk-ins" while it fades.
  const lastNames = useRef<string[]>([]);
  if (pending) lastNames.current = pending.context.zoneNames;
  const names = lastNames.current;
  const zones = names.join(" y ");

  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) close(false);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {names.length === 1
              ? `${zones} es solo para walk-ins`
              : `${zones} son solo para walk-ins`}
          </AlertDialogTitle>
          <AlertDialogDescription>
            Esta zona se reserva para quien llega sin reserva, y el sistema nunca la sugiere para
            una reserva. ¿Poner esta reserva aquí de todas formas?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)}>Elegir otra mesa</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)}>Reservar aquí igual</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
